import { Component, Vue, Prop, Emit, Inject } from 'vue-property-decorator';
import type { IBriefingPage, IResourceModel, UserProfileInfo } from '@/shared/model/briefing-widget.model';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
const appStoreState = namespace('appStore');

const briefingStore = namespace('briefingStore');

@Component({})
export default class GoCardFooterVer2 extends Vue {
  @Prop(Boolean) readonly ableAddReference: boolean | true;
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) isCompanyCard: boolean | false;
  @Prop(String) companyBpId: string;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  /*Tao bien show footer*/

  @appStoreState.Mutation
  public setIsShowShareReport!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowShareTopic!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowBackdrop!: (payload: boolean) => void;

  @briefingStore.Mutation
  public setSelectedResource!: (payload: IResourceModel) => void;

  @briefingStore.Getter
  public getFeaturedPages!: IBriefingPage[];

  @briefingStore.Getter
  public getSocialPages!: IBriefingPage[];

  @briefingStore.Mutation
  public setFeaturedPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setSocialPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setCompanyPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Getter
  public getCompanyPages!: IBriefingPage[];

  @briefingStore.Mutation
  public setFeaturedCompanies: (payload: IResourceModel[]) => void;

  @briefingStore.Getter
  public getFeaturedCompanies!: IResourceModel[];

  @briefingStore.Getter
  public getTotalSubscribeCompany!: number;

  @briefingStore.Mutation
  public setTotalSubscribeCompany: (payload: number) => void;

  private isCanHide: boolean;

  isLoadingSubcribe = false;
  briefingPage: IBriefingPage;

  saveToResource(isResource: boolean) {
    this.$emit('saveToResource', isResource);
  }

  @Emit('toggle-resource') toggleResource() {}

  @Emit('goover') goover() {}

  share() {
    // this.$emit('share');
    if (this.formModel.type === 'REPORT') {
      this.setSelectedResource(this.formModel);
      this.setIsShowBackdrop(true);
      this.setIsShowShareReport(true);
      setTimeout(() => {
        this.$root.$emit('shareReport', this.formModel.docId);
      }, 50);
    } else if (this.formModel.type === 'TOPIC_SUMMARY') {
      this.setSelectedResource(this.formModel);
      this.setIsShowBackdrop(true);
      this.setIsShowShareTopic(true);
    } else {
      this.setSelectedResource(this.formModel);
      this.setIsShowBackdrop(true);
      this.setIsShowShareReport(true);
      setTimeout(() => {
        this.$root.$emit('shareReport', this.formModel.docId);
      }, 50);
    }
  }

  @Emit('hide') hideCard() {
    this.handleClickDropDown();
  }
  @Emit('addToReference') addToReference() {}

  @briefingStore.Getter
  getReferenceDocuments!: Array<any>;

  created() {
    // console.log("router: ", this.$router.currentRoute.name)
    this.isCanHide = !this.$router.currentRoute.name.includes('Home');
  }

  handleClickDropDown() {
    const button = document.getElementById('dropDownReportButton' + this.formModel?.docId);

    if (button) {
      button.click();
    }
  }
  subscribeToCompany(): void {
    if (!this.formModel) return;

    this.isLoadingSubcribe = true;
    const { subscribeStatus, cmp_bp_id, countSubscribe } = this.formModel;
    const isCurrentlySubscribed = subscribeStatus === 'SUBSCRIBE';
    const newStatus = isCurrentlySubscribed ? 'UN_SUBSCRIBE' : 'SUBSCRIBE';
    const updatedSubscribeCount = countSubscribe + (isCurrentlySubscribed ? -1 : 1);

    this.fetchBriefingInfo(cmp_bp_id) // Fetch briefing info before updating status
      .then(() => {
        return this.briefingService().updateSubscribeBriefingPage(this.companyBpId, newStatus);
      })
      .then(() => {
        this.updateStoreWithBriefingPage(newStatus, updatedSubscribeCount);
      })
      .catch(error => console.error('Error updating subscription status:', error))
      .finally(() => {
        this.isLoadingSubcribe = false;
      });
  }

  private async fetchBriefingInfo(cmp_bp_id: string): Promise<void> {
    try {
      const response = await this.briefingService().getBriefingInfo(cmp_bp_id);
      if (response?.data?.body) {
        this.briefingPage = response.data.body;
      } else {
        console.error('Unexpected response structure:', response);
      }
    } catch (error) {
      console.error('Error fetching briefing info:', error);
      throw error; // Re-throw the error to be caught in the subscribeToCompany method
    }
  }

  private updateStoreWithBriefingPage(newStatus: string, subscribeCount: number) {
    this.formModel.subscribeStatus = newStatus;
    this.formModel.countSubscribe = subscribeCount;

    if (newStatus === 'SUBSCRIBE') {
      const featuredIndex = this.getFeaturedCompanies.findIndex(e => {
        if (this.$route.name === 'CompanyBriefing-All') {
          return e.cmp_bp_id.toLowerCase() === this.briefingPage.bpId.toLowerCase();
        } else {
          return e.bpId.toLowerCase() === this.briefingPage.bpId.toLowerCase();
        }
      });
      if (featuredIndex >= 0) {
        this.getFeaturedCompanies.splice(featuredIndex, 1);
        this.setTotalSubscribeCompany(this.getTotalSubscribeCompany + 1);
      }
      this.getCompanyPages.unshift({ ...this.briefingPage, subscribeStatus: newStatus, subscribeCount });
    } else {
      const socialIndex = this.getCompanyPages.findIndex(e => e.bpId.toLowerCase() === this.briefingPage.bpId.toLowerCase());
      if (socialIndex >= 0) {
        this.getCompanyPages.splice(socialIndex, 1);
        this.setTotalSubscribeCompany(this.getTotalSubscribeCompany - 1);
      }
    }
    // console.log('this.getTotalSubscribeCompany: ', this.getTotalSubscribeCompany);
    this.setFeaturedCompanies(this.getFeaturedCompanies);
    this.setCompanyPages(this.getCompanyPages);
  }
}
